import { axios } from '@/services/axios';

export const createTRSRegistration = (data) => {
    const endpoint = '/TRSRegistration';
    return axios.post(endpoint, data);
};
